// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (max-width: 991px) {
  .projectsContainer h1 {
    font-size: 2.5rem;
  }

  .projectCard:first-child {
    margin-top: 25%;
  }

  .projectTagsWrapper p {
    color: #56acb7;
    margin-right: 16px;
  }

  .projectCard h6 {
    width: 100%;
    color: #777;
    text-align: justify;
    margin-top: 24px;
  }

  .projectImgWrapper {
    margin-top: 24px;
  }

  .projectImgWrapper img {
    height: 170px;
    padding: 12px;
    margin-left: 8px;
    object-fit: contain;
  }
}

@media screen and (min-width: 992px) {
  /* .projectCard {
    margin-top: 4%;
  } */
  .projectTagsWrapper p {
    background-color: #56acb7;
    color: white;
    margin-right: 8px;
    padding: 10px;
    border-radius: 4px;
  }

  .projectCard h6 {
    width: 60%;
    color: #777;
    text-align: justify;
    margin-top: 24px;
  }

  .projectImgWrapper {
    margin-top: 42px;
  }

  .projectImgWrapper img {
    height: 240px;
    padding: 12px;
    margin: 14px;
  }
}

.projectsContainer {
  display: flex;
  flex-direction: column;
  /* align-items: center; */
  /* justify-content: center; */
  flex-wrap: wrap;
  width: 100%;
}

.projectsContainer h1 {
  font-size: 48px;
}

.projectsContainer p {
  max-width: 70%;
  margin-top: 24;
  color: #777;
  text-align: justify;
}
`, "",{"version":3,"sources":["webpack://./src/components/projects/Projects.css"],"names":[],"mappings":"AAAA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,aAAa;IACb,gBAAgB;IAChB,mBAAmB;EACrB;AACF;;AAEA;EACE;;KAEG;EACH;IACE,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,aAAa;IACb,YAAY;EACd;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,6BAA6B;EAC7B,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,WAAW;EACX,mBAAmB;AACrB","sourcesContent":["@media screen and (max-width: 991px) {\n  .projectsContainer h1 {\n    font-size: 2.5rem;\n  }\n\n  .projectCard:first-child {\n    margin-top: 25%;\n  }\n\n  .projectTagsWrapper p {\n    color: #56acb7;\n    margin-right: 16px;\n  }\n\n  .projectCard h6 {\n    width: 100%;\n    color: #777;\n    text-align: justify;\n    margin-top: 24px;\n  }\n\n  .projectImgWrapper {\n    margin-top: 24px;\n  }\n\n  .projectImgWrapper img {\n    height: 170px;\n    padding: 12px;\n    margin-left: 8px;\n    object-fit: contain;\n  }\n}\n\n@media screen and (min-width: 992px) {\n  /* .projectCard {\n    margin-top: 4%;\n  } */\n  .projectTagsWrapper p {\n    background-color: #56acb7;\n    color: white;\n    margin-right: 8px;\n    padding: 10px;\n    border-radius: 4px;\n  }\n\n  .projectCard h6 {\n    width: 60%;\n    color: #777;\n    text-align: justify;\n    margin-top: 24px;\n  }\n\n  .projectImgWrapper {\n    margin-top: 42px;\n  }\n\n  .projectImgWrapper img {\n    height: 240px;\n    padding: 12px;\n    margin: 14px;\n  }\n}\n\n.projectsContainer {\n  display: flex;\n  flex-direction: column;\n  /* align-items: center; */\n  /* justify-content: center; */\n  flex-wrap: wrap;\n  width: 100%;\n}\n\n.projectsContainer h1 {\n  font-size: 48px;\n}\n\n.projectsContainer p {\n  max-width: 70%;\n  margin-top: 24;\n  color: #777;\n  text-align: justify;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
